import {ExamSubmissionDto, UserDto} from '../../scaffold';

export default function ExamSubmissionKeywordFilter(examSubmission: ExamSubmissionDto, keyword: string) {
  const str = (examSubmission.student?.name || '') + (examSubmission.student?.username || '');
  return str.includes(keyword);
}
